<template>
  <div class="invoice">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>确认发票</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/exinfo/invoice-alter');">
          <span>返回</span>
        </div>
      </div>
    </div>

    <div class="invoice-content">
      <Form
        ref="formInline2"
        :model="formInline2"
        :rules="ruleInline2"
        label-position="right"
        :label-width="150"
        @submit.native.prevent
      >
        <p style="padding-left: 150px;color: #ff0000;line-height: 34px;">请保证您填写的发票信息正确无误</p>
        <FormItem label="发票抬头：" prop="Title">
          <Input type="text" style="width:600px;" v-model="formInline2.Title" placeholder="请输入您营业执照上的全称" />
        </FormItem>
        <FormItem label="税务登记证号：" prop="Code">
          <Input type="text" style="width:600px;" v-model="formInline2.Code" placeholder="请输入15到20位有效纳税人识别号" />
          <p
            style="font-size: 14px;color: #808080;line-height: initial;padding-top:5px;"
          >请与贵公司财务人员核实后，仔细填写准确的三证合一后的社会统一信用代码或税务登记证号，否则将影响后续发票的正常使用</p>
        </FormItem>
        <FormItem label="开户银行名称：" prop="BankName">
          <Input type="text" style="width:600px;" v-model="formInline2.BankName" placeholder="请输入您开户许可证上的开户银行" />
        </FormItem>
        <FormItem label="开户银行账号：" prop="BankNumber">
          <Input type="text" style="width:600px;" v-model="formInline2.BankNumber" placeholder="请输入您开户许可证上的银行账号" />
        </FormItem>
        <FormItem label="注册场所地址：" prop="Address">
          <Input type="text" style="width:600px;" v-model="formInline2.Address" placeholder="请输入您营业执照上的注册地址" />
        </FormItem>
        <FormItem label="注册固定电话：" prop="Tel">
          <Input type="text" style="width:600px;" v-model="formInline2.Tel" placeholder="请输入您公司有效的联系电话" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="large"
            :loading="loading"
            @click="handleSubmit('formInline2')"
            style="width: 154px;"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-invoice",
  data() {
    return {
      invoiceDownInfo: null,
      loading: false,

      formInline2: {
        // form双向绑定
        Title: "", // 发票抬头
        Code: "", // 税务登记证号(纳税人识别号)
        BankName: "", // 开户银行名称
        BankNumber: "", // 开户银行账号
        Address: "", // 注册场所地址
        Tel: "" // 注册固定电话
      },
      ruleInline2: {
        // 效验规则
        Title: [{ required: true, message: "发票抬头", trigger: "blur" }],
        Code: [
          {
            required: true,
            message: "税务登记证号(纳税人识别号)不能为空",
            trigger: "blur"
          },
          {
            type: "string",
            min: 15,
            message: "税务登记证号小于15位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 20,
            message: "税务登记证号大于20位",
            trigger: "blur"
          }
        ],
        BankName: [
          { required: true, message: "开户银行名称不能为空", trigger: "blur" }
        ],
        BankNumber: [
          { required: true, message: "开户银行账号不能为空", trigger: "blur" }
        ],
        Address: [
          { required: true, message: "注册场所地址不能为空", trigger: "blur" }
        ],
        Tel: [{ required: true, message: "固定电话不能为空", trigger: "blur" }]
      },
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "国际焙烤展 - 确认发票";
    this.init();
  },
  methods: {
    ...mapActions({
      getInvoiceDown: "exhibitionModule/getInvoiceDown",
      editInvoiceDown: "exhibitionModule/editInvoiceDown",
    }),
    async init() {
      // 获取发票修改记录
      let result = await this.getInvoiceDown(this.joinInfo.joinId);
      if (result) {
        this.invoiceDownInfo = result;
        this.formInline2.Title = result.title;
        this.formInline2.Code = result.code;
        this.formInline2.BankName = result.bank;
        this.formInline2.BankNumber = result.bankAccount;
        this.formInline2.Address = result.address;
        this.formInline2.Tel = result.tel;
        console.log("invoiceDownInfo：",this.invoiceDownInfo)
      }
    },
    async handleSubmit(name) {
      let form = this.formInline2;
      let valid = await this.validForm(name);
      if (!valid) return;

      let req = {
        Id: this.invoiceDownInfo.id,
        SetValues: {
          Title: form.Title,
          Code: form.Code,
          Address: form.Address,
          Tel: form.Tel,
          BankAccount: form.BankNumber,
          Bank: form.BankName
        }
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let result = await this.editInvoiceDown(req);
      if (result && result.successed) {
        this.$Message.success("保存成功，请等待审核");
        this.$router.push("/exhibition/index/exinfo/invoice-alter");
      } else {
        this.$Message.warning(`保存失败，请重试`);
      }
      setTimeout(() => {
        this.loading = false;
      },1000);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.invoice {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
}
</style>
